import { applyMiddleware, combineReducers, createStore } from 'redux';
import { composeWithDevTools } from '@redux-devtools/extension';
import ageCheckReducer from './ducks/ageCheck/reducers';
import { itemsReducer, searchSummaryReducer }  from './ducks/items/reducers';
import filtersReducer from './ducks/filters/reducers';
import initialState from './initialState';
import searchReducer from './ducks/search/reducers';
import { thunk } from 'redux-thunk'

function configureStore() {
  const rootReducer = combineReducers({
    items: itemsReducer,
    filters: filtersReducer,
    search: searchReducer,
    ageCheck: ageCheckReducer,
    searchSummary: searchSummaryReducer
  });

  return createStore(
    rootReducer,
    initialState,
    composeWithDevTools(applyMiddleware(thunk))
  );
}

const store = configureStore(initialState);

export default store;
